import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import { toast } from "sonner";
import { ToastProps, ToastConfig } from "../types";
interface CustomToastProps extends ToastProps {
  config: ToastConfig;
}
export const CustomToast = props => {
  const $ = _c(35);
  const {
    id,
    title,
    description,
    config
  } = props;
  const {
    icon: Icon,
    rootClassName,
    iconWrapperClassName,
    iconClassName,
    titleClassName,
    descriptionClassName
  } = config;
  let t0;
  if ($[0] !== rootClassName) {
    t0 = cn("min-w-0 w-full max-w-md rounded-2xl border px-4 py-3 backdrop-blur-xl sm:min-w-[320px]", rootClassName);
    $[0] = rootClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== iconWrapperClassName) {
    t1 = cn("flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl", iconWrapperClassName);
    $[2] = iconWrapperClassName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== iconClassName) {
    t2 = cn("h-5 w-5", iconClassName);
    $[4] = iconClassName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== Icon || $[7] !== t2) {
    t3 = <Icon className={t2} />;
    $[6] = Icon;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== titleClassName) {
    t5 = cn("text-sm font-medium leading-5", titleClassName);
    $[12] = titleClassName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5 || $[15] !== title) {
    t6 = <div className={t5}>{title}</div>;
    $[14] = t5;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== description || $[18] !== descriptionClassName) {
    t7 = description && <div className={cn("mt-1 text-sm leading-5", descriptionClassName)}>{description}</div>;
    $[17] = description;
    $[18] = descriptionClassName;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="flex min-w-0 flex-1 flex-col items-start justify-center pt-0.5">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== id) {
    t9 = () => toast.dismiss(id);
    $[23] = id;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <X className="h-4 w-4" />;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t9) {
    t11 = <button onClick={t9} type="button" aria-label="Dismiss notification" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white/5 text-white/50 transition-colors hover:bg-white/10 hover:text-white/80">{t10}</button>;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t4 || $[30] !== t8) {
    t12 = <div className="flex items-start gap-3">{t4}{t8}{t11}</div>;
    $[28] = t11;
    $[29] = t4;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t0 || $[33] !== t12) {
    t13 = <div className={t0}>{t12}</div>;
    $[32] = t0;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};